export default __webpack_public_path__ + "static/media/cotton.3db6f319.jpg";